import { useState } from "react";
import { RuleProvider, useRule } from "./RuleReducer";
import { useDispatch, useSelector } from "react-redux";
import { checkSiteExists } from "../../../../../Api Methods/Api";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import Button2 from "../../../Button/Button2";
import ChooseWhatAddAdvRuleAction from "./ChooseWhatAddAdvRuleAction";

const AddAdvRuleAction = ({rule, actions, conditions, pins, smartLocks, closeDialog, setNewSelectedPin}) => {

    const { state, dispatch } = useRule(RuleProvider);
    const [progress, setProgress] = useState(60);
    const [message, setMessage] = useState("");
    const [linkAnotherSiteVisible, setLinkAnotherSiteVisible] = useState(false);
    const [siteID, setSiteID] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [linkedSites, setLinkedSites] = useState([]);
    const [selectedPinsToAffect, setSelectedPinsToAffect] = useState([]) // dynamic linked sites


    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const _dispatch = useDispatch();

    const filteredPins = pins.filter(pin =>
        pin.type !== "INPUT" &&
        pin.type !== "VIRTUAL_INPUT" &&
        !smartLocks.some(lock => parseInt(lock.outputPin) === pin.Pin) &&
        pin.Pin !== conditions[0].pin && 
        !actions.some(action => action.target_output === pin.Pin)
    ).map(pin => ({ ...pin, DeviceUUID: rule.site_owner}));

    const HandlePinSelected = (pin) => {
        const isSelected =
            selectedPinsToAffect.length === 1 &&
            selectedPinsToAffect[0].Pin === pin.Pin &&
            selectedPinsToAffect[0].DeviceUUID === pin.DeviceUUID;

        const updatedList = isSelected
            ? []           
            : [pin];

        setSelectedPinsToAffect(updatedList);
        setNewSelectedPin(updatedList)

        const action = {
            site_to: pin.DeviceUUID,
            action_type: "CONTROL_OUTPUT",
            execution_order: actions.length + 1,
            delay_seconds: 0,
            control_type: "",
            target_output: String(pin.Pin)
        }

        dispatch({
            type: "SET_ACTION_TO_ADD",
            payload: action
        })
    };

    const CheckSiteExists = async () => {
        setErrorMessage("");
        const response = await checkSiteExists({ token, client }, siteID, _dispatch);
        if (response.data) {
            if (response.data.error) {
                setErrorMessage("No site found matching that Site ID, please check and try again.");
            } else {
                const site = response.data.device;
                const deviceDetails = JSON.parse(site.deviceDetails);

                const pinsArray = Object.entries(deviceDetails)
                    .filter(([pinNumber, pin]) => pin && typeof pin === "object")
                    .map(([pinNumber, pin]) => ({
                        ...pin,
                        Pin: Number(pinNumber),
                        DeviceUUID: site.uuid
                    }))
                    .filter(pin => pin.type !== "INPUT" && pin.type !== "VIRTUAL_INPUT");

                setLinkedSites(prev => [...prev, { ...site, pins: pinsArray }]);
                setLinkAnotherSiteVisible(false);
                setSiteID("");
            }
        }
    };

    const HandleNext = () => {
        closeDialog();
        
    }

    return (
        <>
            <Dialog
                header="Please enter the Site ID of the site you want to link below"
                visible={linkAnotherSiteVisible}
                style={{ width: "40vw" }}
                onHide={() => setLinkAnotherSiteVisible(false)}
            >
                {errorMessage && <p>{errorMessage}</p>}
                <div>
                    <InputText
                        value={siteID}
                        onChange={(e) => setSiteID(e.target.value)}
                    />
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        label="Link site"
                        severity="success"
                        disabled={siteID === "" || siteID.length !== 8}
                        onClick={CheckSiteExists}
                        icon="pi pi-check" 
                    />
                </div>
            </Dialog>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
                <h3 style={{ color: "#6e6e6e" }}>Which switch will change state when the rule triggers?</h3>
                {message && <p style={{ color: "red" }}>{message}</p>}

                <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }}>
                    {[
                        { key: "This site", pins: filteredPins },
                        ...linkedSites.map(site => ({ key: site.key, pins: site.pins }))
                    ].map((site, siteIndex) => (
                        <div key={siteIndex} style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", marginBottom: "20px" }}>
                            <h3 style={{ color: "#6e6e6e" }}>{site.key}</h3>
                            <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {site.pins.map((pin, index) => (
                                    <Button2
                                        key={index}
                                        onClick={() => HandlePinSelected(pin)}
                                        style={{
                                            minWidth: "350px",
                                            minHeight: "50px",
                                            backgroundColor: selectedPinsToAffect.find(
                                                p => p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID
                                            ) ? "var(--Primary-Color)" : undefined,
                                            color: selectedPinsToAffect.find(
                                                p => p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID
                                            ) ? "white" : undefined,
                                            border: selectedPinsToAffect.find(
                                                p => p.Pin === pin.Pin && p.DeviceUUID === pin.DeviceUUID
                                            ) ? "2px solid lightblue" : undefined
                                        }}
                                    >
                                        {pin.pinName}
                                    </Button2>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <Button
                        label="Affect switches on another site?"
                        rounded
                        severity="info"
                        onClick={() => setLinkAnotherSiteVisible(true)}
                        icon="pi pi-search" 
                    />

                    <Button
                        label="Next"
                        rounded
                        severity="success"
                        disabled={selectedPinsToAffect.length == 0}
                        onClick={() => HandleNext()}
                        icon="pi pi-chevron-right" 
                    />
                </div>
            </div>
        </>
    )
}

export default AddAdvRuleAction;